import config from 'config';
import { http_client } from './api';

const getList = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'materi?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'materi/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const create = async (data) => {
  return http_client.post(config.apiUrl + 'materi', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'materi/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.post(config.apiUrl + 'materi/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'materi/' + id).then((response) => {
    return response.data;
  });
};

const getFile = async (id) => {
  return http_client.get(config.apiUrl + 'materi/file/' + id).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'materi/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, page = null, perPage = null, sort = null, orderBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'materi/' +
        id +
        '/ratings?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const MateriService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  getFile,
  changeStatus,
  getRatings
};

export default MateriService;
